import { useState } from 'react'

interface WidgetPageManagementProps {
  initialPage?: number
  itemsPerPage: number
  persistClickedItem: (index: number | undefined) => void
}

export const useWidgetPageManagementHooks = ({
  initialPage = 1,
  itemsPerPage,
  persistClickedItem,
}: WidgetPageManagementProps) => {
  const [offsetValue, setOffsetValue] = useState(
    (initialPage - 1) * itemsPerPage,
  )

  const setURLState = (offset: number) => {
    const currentPage = offset / itemsPerPage + 1
    persistClickedItem(currentPage)
    setOffsetValue(offset)
  }

  return {
    offsetValue,
    setURLState,
  }
}
